const moment = require("moment");
const utils = require("Sources/utils/utils");

module.exports = class ProfileSubscriptionGuest
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.subscriptionGuestKey = options["subscription-guest-key"];
    this.subscriptionKey = options["subscription-key"];
    this.organisation = options.organisation;
    this.validUntil = options["valid-until"];
  };

  set validUntil(date)
  {
    this._validuntil = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  };

  get validUntil()
  {
    return utils.isMomentObject(this._validuntil) ? this._validuntil.format("DD-MM-YYYY") : null;
  };
};



// WEBPACK FOOTER //
// ./app/js/models/profile-subscription-guest.js